import React from 'react';

import { RowButton } from '@eika/button';

import type { Currency } from '../../../generated-types';
import { SelectList } from '../../shared/SelectList';
import useFormContext from './form/useFormContext';

interface Props {
    onChange: (value: Currency) => void;
    setOpen: (close: boolean) => void;
    onCloseTransferModal?: (close: boolean) => void;
}

const TransferCurrency: React.FC<Props> = ({ onChange, setOpen, onCloseTransferModal }) => {
    const { state } = useFormContext();

    return (
        <SelectList>
            {state.country?.transferCurrencies?.map((currencyItem) => (
                <li key={currencyItem.name} className="currency-field__list-item">
                    <RowButton
                        className="currency-field__list-item-button"
                        onClick={() => {
                            onChange(currencyItem.currency);
                            setOpen(false);
                            onCloseTransferModal?.(false);
                        }}
                    >{`${currencyItem.currency} - ${currencyItem.name}`}</RowButton>
                </li>
            ))}
        </SelectList>
    );
};

export default TransferCurrency;
